module.exports = __webpack_public_path__ + "static/media/marcas2.05332f48.png";